import React from "react";
import { Navigate } from "react-router-dom";
import { useStore } from "../_Store";

const ActiveFarmRequiredRoute = ({ children }) => {
  const {
    state: { activeFarm },
  } = useStore();

  if (!activeFarm || !activeFarm.id) {
    return <Navigate to="/farms" replace />;
  }
  return children;
};

export default ActiveFarmRequiredRoute;
